import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Box } from '@uhg-abyss/web/ui/Box';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { event } from '@uhg-abyss/web/tools/event';
import PropTypes from 'prop-types';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { coveo } from '@src/tools/coveo';

export const ResultLink = ({ headlessEngine, result, index }) => {
  const interactiveResult = coveo.controllers.interactiveResults(
    headlessEngine,
    result
  );
  const getDate = (date) => {
    return dayjs(date).format('MMM D, YYYY');
  };
  const handleLinkClickEvent = (linkName, position, url) => {
    interactiveResult.select();
    event('COVEO_RESULT_LINK_CLICK', {
      searchResultLink: linkName,
      searchResultPosition: position,
    });

    event('EXIT_LINK_NAVIGATE', {
      linkText: linkName,
      linkUrl: url,
    });
  };

  return (
    <Card.Section key={index}>
      <If
        condition={
          getFeature('CORE_COVEO_SUGGESTED_BADGE') && result.isRecommendation
        }
      >
        <Badge
          icon={
            <IconSymbol
              icon='check_circle'
              size='$sm'
              color='$interactive1'
              variant='filled'
            />
          }
          variant='info'
          outline
          css={{ 'abyss-badge-root': { borderWidth: '1px' } }}
        >
          SUGGESTED
        </Badge>
      </If>
      <Box color='white' data-testid='result-link-box'>
        <Layout.Stack alignItems='left'>
          <Link
            fontWeight='bold'
            size='20px'
            href={result.clickUri}
            onClick={() =>
              handleLinkClickEvent(result.title, index + 1, result.clickUri)
            }
          >
            {result.title}
          </Link>
          <Layout.Group>
            <If condition={result.raw.commonformat}>
              <Badge variant='neutral' outline>
                {result.raw.commonformat}
              </Badge>
            </If>
            <Text size='$sm' fontWeight='bold'>
              LAST MODIFIED: {`${getDate(result.raw.sitemaplastmodified)}`}{' '}
            </Text>
          </Layout.Group>

          <Text>{result.raw.sitemapdescription}</Text>
        </Layout.Stack>
      </Box>
    </Card.Section>
  );
};

ResultLink.propTypes = {
  headlessEngine: PropTypes.shape({
    state: {
      search: PropTypes.shape({}),
    },
  }).isRequired,
  result: {
    isRecommendation: PropTypes.bool,
    title: PropTypes.string,
    raw: {
      commonformat: PropTypes.string,
      sitemaplastmodified: PropTypes.number,
      sitemapdescription: PropTypes.string,
    },
  },
  index: PropTypes.number,
};

ResultLink.defaultProps = {
  result: {},
  index: null,
};
